export default "__VITE_ASSET__7ba65d6a__"